import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['link', 'countdown'];
  static values = {
    durationSeconds: { type: Number, default: 90 },
    initialRemainingSeconds: { type: Number, default: 0 },
    remainingSeconds: { type: Number, default: 0 },
  };

  connect() {
    if (this.initialRemainingSecondsValue > 0) {
      this.#startCountdownWith(this.initialRemainingSecondsValue);
    } else {
      this.#enable();
    }
  }

  disconnect() {
    clearInterval(this.timer);
  }

  resend(event) {
    if (this.remainingSecondsValue > 0) {
      event.preventDefault();
      return;
    }

    this.#startCountdownWith(this.durationSecondsValue);
  }

  #startCountdownWith(seconds) {
    this.remainingSecondsValue = seconds;
    this.#disable();
    this.#updateDisplay();

    this.timer = setInterval(() => {
      this.remainingSecondsValue -= 1;

      if (this.remainingSecondsValue <= 0) {
        clearInterval(this.timer);
        this.#enable();
      } else {
        this.#updateDisplay();
      }
    }, 1000);
  }

  #disable() {
    this.linkTarget.classList.add('pe-none');
    this.linkTarget.style.opacity = '0.5';
    this.linkTarget.setAttribute('aria-disabled', 'true');
    this.countdownTarget.classList.remove('d-none');
  }

  #enable() {
    this.linkTarget.classList.remove('pe-none');
    this.linkTarget.style.opacity = '';
    this.linkTarget.removeAttribute('aria-disabled');
    this.countdownTarget.classList.add('d-none');
  }

  #updateDisplay() {
    this.countdownTarget.textContent = `(${this.remainingSecondsValue}s)`;
  }
}
